import {
  useShareableDomainReviewComponents,
  useShareablePageReviewComponents,
} from 'common/hooks/useShareableReviewComponents'
import ShareButtons from 'cc/ShareButtons'
import CopyToClipboard from 'cc/CopyToClipboard'

const DoShareReview = ({
  getterFn,
  author,
  review,
  domainKey,
  pageKey,
  components,
  className = 'p-3 rounded bg-gray-100',
  showUrl,
  numBtns,
  ...props
}) => {
  const whatToShare = getterFn({
    review,
    author,
    domainKey,
    pageKey,
    alreadyParsed: components,
  })

  return (
    <div className={className}>
      {showUrl && <CopyToClipboard value={whatToShare.url} label="Copy View URL" />}
      <ShareButtons {...whatToShare} num={numBtns} {...props} />
    </div>
  )
}

export const ShareDomainReview = (props) => <DoShareReview getterFn={useShareableDomainReviewComponents} {...props} />

export const SharePageReview = (props) => <DoShareReview getterFn={useShareablePageReviewComponents} {...props} />

const ShareReview = ({ pageKey, ...props }) => {
  return pageKey ? <SharePageReview pageKey={pageKey} {...props} /> : <ShareDomainReview {...props} />
}
export default ShareReview
